import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Gamepad2, PenTool, Newspaper, ArrowUpRight } from "lucide-react";

const FEATURES = [
  { icon: Gamepad2, t: "Learn & Play", d: "Quizzes and the Guess-the-EMI challenge that sharpen your money instincts.", to: "/games", img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1000" },
  { icon: PenTool, t: "Draw Your Dream Home", d: "Sketch your ideal floor plan or facade on an interactive canvas.", to: "/games", img: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1000" },
  { icon: Newspaper, t: "Market News", d: "Live real-estate headlines from across India, updated continuously.", to: "/news", img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1000" },
];

export function FeatureGrid() {
  return (
    <section className="border-t border-border py-24 md:py-36" data-testid="feature-grid">
      <div className="container-px mx-auto max-w-[1600px]">
        <Reveal>
          <h2 className="mb-16 max-w-3xl font-display text-4xl font-extrabold uppercase leading-none text-foreground md:text-6xl">
            More than a website. <span className="text-muted-foreground">A place to learn.</span>
          </h2>
        </Reveal>
        <div className="grid gap-6 md:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.t} delay={i * 0.1}>
              <Link to={f.to} className="group block overflow-hidden border border-border bg-card" data-testid={`feature-${i}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={f.img} alt={f.t} className="h-full w-full object-cover transition-all duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent" />
                  <f.icon className="absolute left-5 top-5 h-11 w-11 border border-border bg-background/90 p-2.5 text-foreground backdrop-blur" strokeWidth={1.5} />
                </div>
                <div className="flex items-center justify-between p-6">
                  <div>
                    <h3 className="font-display text-2xl font-bold uppercase text-foreground">{f.t}</h3>
                    <p className="mt-1 text-sm text-muted-foreground">{f.d}</p>
                  </div>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-muted-foreground transition-all group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-cyan" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
